class GoogleAuth {
  constructor() {
    "ngInject";
    this.auth2 = null;
  }
  renderSignInButton(onSuccess, onFailure) {
    gapi.signin2.render("g-signin2", {
      scope: "profile email",
      width: 330,
      height: 40,
      longtitle: true,
      onsuccess: onSuccess,
      onfailure: onFailure,
    });
  }
  async initialize() {
    return new Promise((resolve) =>
      gapi.load("auth2", async () => {
        // Retrieve the singleton for the GoogleAuth library and set up the client.
        this.auth2 = await gapi.auth2.init({
          client_id: process.env.DASHBOARD_GOOGLE_CLIENT_ID,
          hosted_domain: "swvl.com",
        });
        resolve();
      })
    );
  }
  signIn() {
    return this.auth2.signIn();
  }
  signOut() {
    return this.auth2.signOut();
  }
  isSignedInWithGoogle() {
    return this.auth2 ? this.auth2.isSignedIn.get() : false;
  }
}

export default GoogleAuth;



// WEBPACK FOOTER //
// ./src/services/googleAuth/googleAuth.service.js